import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Card, Button, Typography, Space, Row, Col, Result } from 'antd';
import { CloseCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import Logo from './Logo';

const { Title, Text } = Typography;

const MicrosoftLoginError = () => {
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error') || 'Ocorreu um erro durante a autenticação com a Microsoft.';

  const MicrosoftIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" style={{ marginRight: 12 }}>
      <rect x="0" y="0" width="11" height="11" fill="#f25022"/>
      <rect x="13" y="0" width="11" height="11" fill="#7fba00"/>
      <rect x="0" y="13" width="11" height="11" fill="#00a4ef"/>
      <rect x="13" y="13" width="11" height="11" fill="#ffb900"/>
    </svg>
  );

  return (
    <Row 
      justify="center" 
      align="middle" 
      style={{ 
        minHeight: '100vh', 
        padding: '24px'
      }}
    >
      <Col xs={22} sm={20} md={16} lg={12} xl={8}>
        <Card
          bordered={false}
          style={{
            borderRadius: 16,
            boxShadow: '0 8px 32px rgba(45, 95, 63, 0.10)',
            border: '2px solid #ae9560'
          }}
          bodyStyle={{ padding: '48px 40px' }}
        >
          <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <Logo size="xlarge" />
              <Title level={4} style={{ margin: 0, color: '#6c757d', fontWeight: 400 }}>
                Erro na autenticação
              </Title>
            </Space>

            <Result
              status="error"
              icon={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
              title={<Text style={{ fontSize: 16 }}>Falha ao autenticar</Text>}
              subTitle={<Text type="secondary">{error}</Text>}
            />

            <Link to="/microsoft-login" style={{ textDecoration: 'none', display: 'block', width: '100%' }}>
              <Button
                type="primary"
                size="large"
                block
                icon={<><MicrosoftIcon /><ReloadOutlined style={{ marginLeft: 8 }} /></>}
                style={{
                  height: 64,
                  fontSize: 16,
                  fontWeight: 600,
                  background: 'linear-gradient(135deg, #024638 0%, #4a7c59 100%)',
                  border: 'none',
                  borderRadius: 8,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                Tentar novamente
              </Button>
            </Link>

            <Text type="secondary" style={{ fontSize: 14, display: 'block', marginTop: 16 }}>
              Use sua conta corporativa ou organizacional da Microsoft
            </Text>
          </Space>
        </Card>
      </Col>
    </Row>
  );
};

export default MicrosoftLoginError; 